import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConsultationNotSavedButtonActionGtm, GTMService, consultationNotSavedButton } from '@app/core/services/tracking';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { RcDialogWrapperComponent } from '../rc-dialog-wrapper/rc-dialog-wrapper.component';
import { TranslatePipe } from '@app/shared/pipes';

export enum PreventExitPopinAction {
  CANCEL = 'cancel',
  NO_SAVE = 'no_save',
  SAVE = 'save',
  PMS_SEND_BACK_DATA = 'send_back_data',
}

@Component({
  selector: 'app-prevent-exit-popin',
  templateUrl: './prevent-exit-popin.component.html',
  styleUrls: ['./prevent-exit-popin.component.scss'],
  imports: [RcDialogWrapperComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PreventExitPopinComponent implements OnDestroy, OnInit {
  private _destroyed$ = new Subject<void>();
  isShowSendBackDataButton: boolean;

  constructor(
    private matDialogRef: MatDialogRef<PreventExitPopinComponent>,
    private trackingService: GTMService,
    @Inject(MAT_DIALOG_DATA) public data: { isShowSendBackDataButton: boolean },
  ) {
    if (data) {
      this.isShowSendBackDataButton = this.data.isShowSendBackDataButton;
    }
  }

  ngOnInit(): void {
    this.trackingService.sendDialogView(!this.isShowSendBackDataButton ? 'Consultation not saved' : 'Pms send back data not sent');
    this.listenOnBackdropClick();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  save() {
    this.trackingService.sendInteraction(consultationNotSavedButton(ConsultationNotSavedButtonActionGtm.SAVE_CONSULTATION));
    this.matDialogRef.close(PreventExitPopinAction.SAVE);
  }

  shareSendBackData() {
    this.trackingService.sendInteraction(consultationNotSavedButton(ConsultationNotSavedButtonActionGtm.PMS_SEND_BACK_DATA));
    this.matDialogRef.close(PreventExitPopinAction.PMS_SEND_BACK_DATA);
  }

  exitWithoutSave() {
    this.trackingService.sendInteraction(consultationNotSavedButton(ConsultationNotSavedButtonActionGtm.EXIT_WITHOUT_SAVING));
    this.matDialogRef.close(PreventExitPopinAction.NO_SAVE);
  }

  closePopin() {
    this.trackingService.sendInteraction(consultationNotSavedButton(ConsultationNotSavedButtonActionGtm.CLOSE));
    this.matDialogRef.close(PreventExitPopinAction.CANCEL);
  }

  private listenOnBackdropClick() {
    this.matDialogRef
      .backdropClick()
      .pipe(
        takeUntil(this._destroyed$),
        tap(() => this.closePopin()),
      )
      .subscribe();
  }
}
